import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FundingStagesCell from './FundingStagesCell';
import { Button, Tooltip, Typography, IconButton } from '@material-ui/core';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { red } from '@material-ui/core/colors';
import { stage2Text, stageSort} from '../utils/formatters';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

const checkForSkippedStage = (currentStage, alreadyPaidStages, otherStagesPaidToday, numberOfPaymentStages) => {
    const isPaid = (stage) => alreadyPaidStages.includes(stage) || otherStagesPaidToday.includes(stage);

    // Stages that must already be paid before the current stage can be paid, based on how
    // many payment stages this loan has (supports 2 through 5 stages). 2-stage loans may
    // label their last payment as 'second' (Vision) or 'final' (Defi), so it only requires 'first'.
    const precedingStages = {
        first: [],
        second: ['first'],
        third: ['first', 'second'],
        fourth: ['first', 'second', 'third'],
        final: numberOfPaymentStages >= 3
            ? ['first', 'second', 'third', 'fourth'].slice(0, numberOfPaymentStages - 1)
            : ['first']
    };

    return (precedingStages[currentStage] || []).some(stage => !isPaid(stage));
}

const PaymentStageCell = (props) => {
    const {value, alreadyPaidStages, otherStagesPaidToday, numberOfPaymentStages } = props;
    return checkForSkippedStage(value, alreadyPaidStages, otherStagesPaidToday, numberOfPaymentStages) ?
        (
          <div style={{display:'flex'}}>
            <FundingStagesCell
                hasStagedFunding={value.toLowerCase() !== 'unstaged'}
                paidStages={alreadyPaidStages}
                heldStages={[]}
                numberOfPaymentStages={numberOfPaymentStages} />
            <HtmlTooltip
                title={
                    <React.Fragment>
                        <Typography color="inherit"><b><u>Completed Stage Payments:</u></b></Typography>
                        <p>{stageSort(alreadyPaidStages.map(stage2Text)).join(', ')}</p>
                        <p>A required preceding stage appears unpaid (a stage may have been skipped).</p>
                    </React.Fragment>
                }
            >
                <IconButton component="span">
                    <WarningRoundedIcon style={{ color: red[500] }} />
                </IconButton>
            </HtmlTooltip>
          </div>
      ) :
      (
        <HtmlTooltip
            title={
                <React.Fragment>
                    <Typography color="inherit"><b><u>Completed Stage Payments:</u></b></Typography>
                    <p>{stageSort(alreadyPaidStages.map(stage2Text)).join(', ')}</p>
                </React.Fragment>
            }
        >
            <Button>
                <FundingStagesCell
                    hasStagedFunding={value.toLowerCase() !== 'unstaged'}
                    paidStages={alreadyPaidStages}
                    heldStages={[]}
                    numberOfPaymentStages={numberOfPaymentStages} />
            </Button>
        </HtmlTooltip>
      )
}

export default PaymentStageCell;